import React from 'react'
import { returnFullURL } from '../../utils/goblaFunctions'
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useParams } from 'react-router-dom';
import { FixedSizeList as OptimizerList, VariableSizeList } from 'react-window';
import { ImagenesGlobal } from '../global/ImagenesGlobal';

const TablesMobile = ({
    filteredData,
    img = false,
    whatsapp = false,
    profile = false,
    type = 'picture',
    functionEspecial = null,
    mode = "normal", //normal, product, venta, reportes
    returnTotal = (() => { }),
    facturado = 0,
    showDetail = (() => { }),
    loadImageS,
    itsCompany = false
}) => {
    const { nit, main_direc, sub_direc } = useParams();

    if (!filteredData || filteredData.length === 0) {
        return <div>No hay datos para mostrar</div>;
    }

    const dom_content = (val_number) => {
        return (
            <a href={`https://wa.me/${val_number}`} target='_blank' className="default-buttons">
                <WhatsAppIcon style={{ color: "#55BC5B", fontSize: "30px" }} />
            </a>
        )
    }

    const getItemSize = index => {
        const item = filteredData?.[index];
        const newSize = typeof item?.height === 'number' ? item.height : 100;
        return newSize + 10; // valor por defecto 100px
    };

    const RowList = ({ style, index }) => {
        const objs = filteredData[index] ?? null;

        let rowSelected = null;

        if (objs) {
            rowSelected = (
                <div style={style}>
                    <li key={`mobile-${main_direc}-${sub_direc}-${nit}-${objs?.img ?? index}`} style={{
                        width: '100%',
                        border: '1.5px solid var(--theme-company)',
                        borderRadius: '40px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '8px',
                        gap: '8px',
                        zIndex: 999,
                        // top: getItemSize() * index + (index == 0 ? 0 : (15 * index))
                    }}
                    >
                        <div style={{
                            display: 'flex',
                            flexFlow: 'row nowrap',
                            gap: '8px',
                            justifyContent: img ? 'space-between' : 'flex-start',
                            width: img ? '80%' : 'fit-content',
                            alignItems: 'center',
                        }}
                        >
                            <div className="profiles-container" onClick={() => showDetail(objs)}>
                                {
                                    profile ? (
                                        <ImagenesGlobal
                                            url={objs?.img}
                                            type={type}
                                            alt={objs?.title ?? ('Imagen' + index)}
                                            loadImageS={loadImageS}
                                        />
                                    ) : (<span>{index + 1}</span>)
                                }
                            </div>

                            {
                                mode == "normal" && (
                                    <div className='information-tables' key={objs?.img ?? index} style={{ alignItems: img ? 'center' : 'flex-start' }}>
                                        {
                                            img && (
                                                <div className="images-container" onClick={() => showDetail(objs)}>
                                                    {
                                                        <ImagenesGlobal
                                                            url={objs?.img}
                                                            type={'picture'}
                                                            alt={objs?.title ?? ('Imagen' + index)}
                                                            loadImageS={loadImageS}
                                                        />
                                                    }
                                                </div>
                                            )
                                        }
                                        <h3 className='limited-text' style={{ fontSize: '1.1rem', fontWeight: 550 }}>{objs?.title}</h3>

                                        {
                                            !img && (<p className='limited-text' style={{ fontWeight: 400 }}>{objs?.texto}</p>)
                                        }
                                    </div>
                                )
                            }

                            {
                                mode == "venta" && (
                                    <div className='information-tables' key={objs?.img ?? index} style={{ alignItems: img ? 'center' : 'flex-start', gap: '0px' }}>
                                        <h3 className='limited-text' style={{ fontSize: '1.1rem', fontWeight: 550, WebkitLineClamp: 1 }}>{objs?.title}</h3>

                                        <span style={{ fontSize: '0.8rem', textTransform: 'uppercase' }}>CÓDIGO: {objs?.code}</span>
                                        <span style={{ fontSize: '0.8rem', textTransform: 'uppercase' }}>CANTIDAD: {objs?.cantidad}</span>

                                        <p className='limited-text' style={{ fontWeight: 550 }}>TOTAL: BS. {objs?.total}</p>
                                    </div>
                                )
                            }

                            {
                                mode == "reportes" && (
                                    <div className='information-tables' key={objs?.img ?? index} style={{ alignItems: img ? 'center' : 'flex-start', gap: '0px' }}>
                                        <h3 className='limited-text' style={{ fontSize: '1.1rem', fontWeight: 550 }}>{objs?.title}</h3>

                                        <span style={{ fontSize: '0.8rem', textTransform: 'uppercase' }}>{objs?.other}</span>

                                        <p className='limited-text' style={{ fontWeight: 700, color: '#000', fontSize: '14px' }}>{objs?.texto}</p>
                                    </div>
                                )
                            }

                        </div>

                        <div>
                            {
                                functionEspecial != null && functionEspecial(objs?.authCode ?? objs, index)
                            }
                            {whatsapp && dom_content(objs?.fullPhone)}
                        </div>
                    </li >
                </div>
            );
        } else {
            rowSelected = (
                <li style={{ ...style, justifyContent: 'center' }}>
                    <span>Sin datos registrados...</span>
                </li>
            );
        }

        return rowSelected;
    }

    const heightConverted = window.innerHeight * 0.64;

    return (
        <>
            <br></br>
            <VariableSizeList
                height={heightConverted}
                itemCount={(filteredData ?? []).length}
                itemSize={getItemSize}
                width={'100%'}
                outerElementType={CustomUL}
            >
                {RowList}
            </VariableSizeList>

            {
                (mode == "venta" || "reportes") && returnTotal() > 0 && (
                    <div className='table-view-mobile' style={{ margin: '0px' }}>
                        {
                            (facturado == 2 || facturado == 1) && <div className='operation-result'>
                                <span style={{ fontWeight: 500 }}>Total facturado: </span>
                                <span>BS. {returnTotal(true)}</span>
                            </div>
                        }

                        {
                            (facturado == 1 || facturado == 0) && <div className='operation-result'>
                                <span style={{ fontWeight: 500 }}>Total sin factura: </span>
                                <span>BS. {returnTotal(false)}</span>
                            </div>
                        }

                        {
                            facturado == null && <div className='operation-result'>
                                <span style={{ fontWeight: 500 }}>Total: </span>
                                <span>BS. {returnTotal()}</span>
                            </div>
                        }
                    </div>
                )
            }
        </>
    )
}

const CustomUL = React.forwardRef(({ style, ...rest }, ref) => (
    <ul ref={ref} {...rest} style={{ ...style, overflow: 'auto' }} />
));

export default TablesMobile